import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ticksToString',
    standalone: false
})
export class TicksToStringPipe implements PipeTransform {
  transform(value: number, format: 'dd' | 'dd hh mm' | 'h' | 'HH:mm' = 'h'): string {
    switch (format) {
      case 'dd': return this.getDayFormat(value);
      case 'dd hh mm': return this.getDayHourMinFormat(value);
      case 'HH:mm': return this.getHourWithoutUnitsFormat(value);
      case 'h':
      default: return this.getHourFormat(value);
    }
  }

  private getDayFormat = (value: number): string => {
    const days = Math.round(value * 1000 / (24 * 60 * 60 * 10e6)) / 1000;

    return `${days}`;
  };

  private getDayHourMinFormat = (value: number): string => {
    const days = Math.floor(value / (24 * 60 * 60 * 10e6));
    const hours = Math.floor((value / (60 * 60 * 10e6)) % 24);
    const minutes = Math.round((value / (60 * 10e6)) % 60);

    return `${days}d ${hours}h ${minutes}min`;
  };

  private getHourFormat = (value: number): string => {
    const hours = Math.floor(value / (60 * 60 * 10e6));
    const minutes = Math.round((value / (60 * 10e6)) % 60);

    return `${hours}h ${minutes}min`;
  };

  private getHourWithoutUnitsFormat = (value: number): string => {
    const hours = Math.floor(value / (60 * 60 * 10e6));
    const minutes = Math.round((value / (60 * 10e6)) % 60);

    return `${hours}:${String(minutes).padStart(2, '0')}`;
  };
}
